/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Button, Alert,
} from 'reactstrap';

import classnames from 'classnames';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { useHistory } from 'react-router-dom';

import {
  Formik, Field, FieldArray, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { get, post } from '../../helpers/api_helper';

function SaleForm(props) {
  const {
    entity,
    t,
  } = props;

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      setLoading(true);
      setErrorMessage(null);
      let result;
      if (entity.id === undefined) {
        result = await post('/api/sales/create', values);
      } else {
        result = await post(`/api/sales/save/${entity.id}`, values);
      }

      toastr.success(t(`Sale ID ${result.id} saved`), t('Success'));
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    shipping_firstname: Yup
      .string()
      .required(props.t(t('First Name is required'))),
    shipping_lastname: Yup
      .string()
      .required(props.t(t('Last Name is required'))),
    billing_firstname: Yup
      .string()
      .required(props.t(t('First Name is required'))),
    billing_lastname: Yup
      .string()
      .required(props.t(t('Last Name is required'))),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={
          {
            shipping_firstname: entity.shipping_firstname,
            shipping_lastname: entity.shipping_lastname,
            billing_firstname: entity.billing_firstname,
            billing_lastname: entity.billing_lastname,
          }
        }
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          touched, errors, values, setFieldValue,
        }) => (
          <Form className="mt-3" id="SaleForm" autoComplete="off">
            {Object.entries(errors).length > 0 && (
              <Alert color="danger">{t('Form contains errors')}</Alert>
            )}
            <Row className="mt-3">
              <Col sm="6">
                <Label
                  for="ship_name"
                >
                  {props.t('Ship To First Name')}
                </Label>
                <Field className="form-control" id="ship_name" name="shipping_firstname" />
                <ErrorMessage
                  name="shipping_firstname"
                  component="div"
                  className="text-danger"
                />
              </Col>

              <Col sm="6">
                <Label
                  for="ship_lname"
                >
                  {props.t('Ship To Last Name')}
                </Label>
                <Field className="form-control" id="ship_lname" name="shipping_lastname" />
                <ErrorMessage
                  name="shipping_lastname"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col sm="6">
                <Label
                  for="bill_name"
                >
                  {props.t('Bill To First Name')}
                </Label>
                <Field className="form-control" id="bill_name" name="billing_firstname" />
                <ErrorMessage
                  name="billing_firstname"
                  component="div"
                  className="text-danger"
                />
              </Col>

              <Col sm="6">
                <Label
                  for="bill_lname"
                >
                  {props.t('Bill To Last Name')}
                </Label>
                <Field className="form-control" id="bill_lname" name="billing_lastname" />
                <ErrorMessage
                  name="billing_lastname"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

SaleForm.defaultProps = {
  entity: {
    shipping_firstname: '',
    shipping_lastname: '',
    billing_firstname: '',
    billing_lastname: '',
  },
  onSuccess: () => {},
};

SaleForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(SaleForm));
